import { labTestCatalogueByLoinc, type ResolvedLabTestBinding } from "@emr/contracts";

/** Server metadata comes only from the approved form instruction concept catalogue. */
export interface FormProposedTest {
  readonly codeSystem: "LOINC" | "local" | "RadLex";
  readonly code: string;
  readonly display: string;
}

export function formProposedTestIdentity(test: FormProposedTest): string {
  return `${test.codeSystem.toUpperCase()}|${test.code}`;
}

/** Preserve exact approved codes. Imaging concepts cannot become laboratory orders. */
export function formProposedLabTest(
  conceptId: string,
  proposedTests: readonly FormProposedTest[] = [],
): ResolvedLabTestBinding | undefined {
  const approved = proposedTests.filter((test) => formProposedTestIdentity(test) === conceptId);
  if (approved.length > 0) {
    const test = approved[0];
    if (!test || test.codeSystem === "RadLex") return undefined;
    if (approved.some((entry) => entry.display !== test.display)) return undefined;
    return { code: test.code, codeSystem: test.codeSystem, display: test.display };
  }
  if (!conceptId.startsWith("LOINC|")) return undefined;
  const code = conceptId.slice("LOINC|".length);
  const entry = labTestCatalogueByLoinc.get(code);
  if (!entry) return undefined;
  return { code, codeSystem: "LOINC", display: entry.display };
}
